/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IMfrmBuybox containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum titleHeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IMfrmBuyboxConfig extends Msdyn365.IModuleConfig {
    showBVRatings?: boolean;
    eComDisplayColorAsDropDown?: string;
    eComDisplayColorLabel?: string;
    titleHeadingTag?: titleHeadingTag;
    className?: string;
    variantNameMapping?: IVariantNameMappingData[];
    enableShopSimilarLooks?: boolean;
    renderOOBMediaGallery?: boolean;
    enableShopSimilarDescription?: boolean;
    enableKeyInPrice?: boolean;
    minimumKeyInPrice?: number;
    maximumKeyInPrice?: number;
    callChatPhoneNumber?: string;
    callChatMessage?: string;
    productId?: string;
    progressiveLeasingEstimator?: IProgressiveLeasingEstimatorData;
    targetAudienceGroup?: string;
    enableVariantSelectionRedesign?: boolean;
    cSatRatingHeadingText?: string;
    cSatRatingPopoverText?: string;
    sleepExpertOpinionHeadingText?: Msdyn365.RichText;
}

export interface IMfrmBuyboxResources {
    closeNotificationLabel: string;
    findInStoreNotAvailableTextButton: string;
    findInStoreNotAvailableDescription: string;
    findInStoreLinkText: string;
    findInStoreHeaderText: string;
    findInStoreDescriptionText: string;
    priceFree: string;
    originalPriceText: string;
    currentPriceText: string;
    addToCartText: string;
    addToCartProductsText: string;
    viewCartLinkText: string;
    outOfStockText: string;
    averageRatingAriaLabel: string;
    selectDimensionFormatString: string;
    productDimensionTypeColor: string;
    productDimensionTypeConfiguration: string;
    productDimensionTypeSize: string;
    productDimensionTypeStyle: string;
    productDimensionTypeAmount: string;
    createOrderTemplateHeader: string;
    orderTemplateTitle: string;
    orderTemplateNameAriaLabel: string;
    createOrderTemplateDescription: string;
    createNewOrderTemplateButtonText: string;
    createOrderTemplateButtonText: string;
    cancelNewOrderTemplateCreationButtonText: string;
    defaultOrderTemplateName: string;
    addToOrderTemplateHeader: string;
    addToOrderTemplateButtonTooltip: string;
    noOrderTemplatesMessage: string;
    noOrderTemplatesDescription: string;
    createAnOrderTemplateButtonText: string;
    cancelOrderTemplateCreationButtonText: string;
    selectTemplatesText: string;
    addToTemplateButtonText: string;
    lineItemsText: string;
    addToOrderTemplateButtonText: string;
    addToOrderTemplateMessage: string;
    addItemToOrderTemplateError: string;
    viewOrderTemplateButtonText: string;
    continueShoppingButtonText: string;
    itemAddedToOrderTemplateHeaderItemOneText: string;
    itemAddedToOrderTemplateHeaderItemFormatText: string;
    itemAddedToOrderTemplateHeaderMessageText: string;
    duplicatedProductsHeader: string;
    duplicatedProductsDescription: string;
    updateQuantityButtonText: string;
    cancelDuplicateItemsButtonText: string;
    addToWishlistButtonText: string;
    removeFromWishlistButtonText: string;
    nameOfWishlist: string;
    inputQuantityAriaLabel: string;
    addToWishlistMessage: string;
    removedFromWishlistMessage: string;
    addItemToWishlistError: string;
    removeItemFromWishlistError: string;
    productQuantityHeading: string;
    errorMessageOutOfStock: string;
    errorMessageOutOfRangeOneLeft: string;
    errorMessageOutOfRangeFormat: string;
    productDimensionTypeColorErrorMessage: string;
    productDimensionTypeConfigurationErrorMessage: string;
    productDimensionTypeSizeErrorMessage: string;
    productDimensionTypeStyleErrorMessage: string;
    productDimensionTypeAmountErrorMessage: string;
    buyboxErrorMessageHeader: string;
    addedToCartFailureMessage: string;
    maxQuantityLimitText: string;
    invalidSmallCustomAmountText: string;
    invalidLargeCustomAmountText: string;
    shopSimilarLooksText: string;
    shopSimilarDescriptionText: string;
    buyBoxGoToCartText: string;
    buyBoxContinueShoppingText: string;
    buyBoxSingleItemText: string;
    buyBoxMultiLineItemFormatText: string;
    buyBoxHeaderMessageText: string;
    maxQuantityText: string;
    minQuantityText: string;
    addedQuantityText: string;
    buyboxKeyInPriceLabelHeading: string;
    descriptionTextToShowAllPickupOptions: string;
    availableInStoresText: string;
    notAvailableInStoresText: string;
    availableInStoresTextV2: string;
    notAvailableInStoresTextV2: string;
    onlineOnlyProductsText: string;
    deliveryBy: string;
    changeZipCode: string;
    enterZipCode: string;
    mfrmOutOfStockText: string;
    mfrmContinueShoppingText: string;
    mfrmInvalidZipCode: string;
    informationIconText: string;
    priceRangeSeparator: string;
    bulkPurchaseLinkText: string;
    viewStoreDetailsText: string;
    changeStoreText: string;
    storeOpenAtHours: string;
    storeCloseAtHours: string;
    storeHoursClosedText: string;
    swatchItemAriaLabel: string;
    salesAgreementPricePrompt: string;
    salesAgreementExpirationDatePrompt: string;
    salesAgreementCommittedQuantityPrompt: string;
    salesAgreementRemainingQuantityPrompt: string;
}

export interface IVariantNameMappingData {
    originalVariantName?: string;
    customizedVariantName?: string;
}

export const enum ProgressiveLeasingEstimatorRequestType {
    pdp = 'pdp',
    checkoutPdp = 'checkoutPdp'
}

export const enum ProgressiveLeasingEstimatorPayFrequency {
    weekly = 'weekly',
    biWeekly = 'biWeekly',
    semiMonthly = 'semiMonthly',
    monthly = 'monthly'
}

export interface IProgressiveLeasingEstimatorData {
    infoText: string;
    progressiveLogo?: Msdyn365.IImageData;
    estimatorLink?: IEstimatorLinkData;
    requestType: ProgressiveLeasingEstimatorRequestType;
    payFrequency: ProgressiveLeasingEstimatorPayFrequency;
    storeId: string;
    approveMeName?: string;
    approveMeSlugValue?: string;
}

export interface IEstimatorLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IMfrmBuyboxProps<T> extends Msdyn365.IModule<T> {
    resources: IMfrmBuyboxResources;
    config: IMfrmBuyboxConfig;
    slots: {
        mediaGallery: React.ReactNode[];
        storeSelector: React.ReactNode[];
        textBlocks: React.ReactNode[];
        socialShare: React.ReactNode[];
        mfrmStoreSelector: React.ReactNode[];
        mfrmMediaGallery: React.ReactNode[];
        additionalModules: React.ReactNode[];
        stylesAndDisruptorsModules: React.ReactNode[];
        completeYourBed: React.ReactNode[];
        chooseYourFoundationModule: React.ReactNode[];
    };
}
